/** GA4 measurement ID for Carrier Passport public marketing/auth pages only. */
export const PASSPORT_PUBLIC_GA_MEASUREMENT_ID = 'G-13E7VQKBGK';

/** Routes that may load gtag and send page views (exact pathname match). */
export const PASSPORT_PUBLIC_ANALYTICS_PATHS = [
  '/',
  '/technology',
  '/for-carriers',
  '/for-brokers',
  '/carrier-verification',
  '/learn/what-brokers-ask-for',
  '/learn/fmcsa-vs-passport',
  '/learn/sharing-credentials-safely',
  '/login',
  '/register'
] as const;

export function isPassportPublicAnalyticsPath(pathname: string): boolean {
  const p = pathname.replace(/\/+$/, '') || '/';
  return (PASSPORT_PUBLIC_ANALYTICS_PATHS as readonly string[]).includes(p);
}
